import(/* webpackMode: "eager" */ "/home/runner/work/Invoice/Invoice/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/Invoice/Invoice/src/app/MotionPause.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/Invoice/Invoice/src/app/Reveal.js");
;
import(/* webpackMode: "eager", webpackExports: ["LiveQuote","TemplateGallery","LetterGallery"] */ "/home/runner/work/Invoice/Invoice/src/components/Site/LiveDocs.js");
